import React, { Component } from "react";
import MainLayout from "../../../components/Layout/MainLayout";
import MapQuyHoach from "../MapQuyHoach";
import { Button, Col, Row, Select, Table } from "antd";
import "../quy-hoach-kien-truc.scss";
import { AxiosGetSecretApi } from "../../../utils/fetchApi";
import SearchResult10000 from "./SearchResult10000";
import { connect } from "react-redux";
import Map from "./Map";
import StaticClass from "../../../utils/staticClass";
class QuyHoach10000 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listNamQH: [],
      listMatBang: [],
      listLoaiDat: [],

      selectedNamQH:  undefined,
      selectedMatBang: undefined,
      selectedLoaiDat: undefined,

      dataTable: [],
      pagination: { pageSize: 10, total: 1, current: 1 },
      isLoading: true,
      currentIndex: null,

      dataSearch: undefined,
      query: '',
      resetButton: false,
      isShowSearchResult: false,
    };

    this.columns = [
      {
        title: "STT",
        dataIndex: "key",
        width: 60,
        align: "center",
      },
      {
        title: <div style={{ textAlign: "center" }}>Loại đất</div>,
        dataIndex: "TenLoaiDat",
      },

      {
        title: <div style={{ textAlign: "center" }}>Diện tích (ha)</div>,
        dataIndex: "DienTich",
        render: (cell, row, index) => {
          let DienTich = row.DienTich;
          return StaticClass.formatPrice(DienTich)
        },
        width: 110,
      },

      {
        title: "Năm quy hoạch",
        dataIndex: "NamQH",
        width: 100,
        align: "center",
      },

      {
        title: "Số quyết định",
        dataIndex: "QuyetDinh",
        width: 100,
        align: "center",
      },
    ];

    this.map = React.createRef();
  }

  componentDidMount() {
    // get data select
    this.getDataNamQH();
    this.getDataLoaiDat();
    this.getDataMatBang();

    this.onSearchClick();
  }
  // --------------------get data select--------------------
  async getDataNamQH() {
    let res = await AxiosGetSecretApi("/api/qh-chung/cbNamQH");
    if (res && Array.isArray(res)) {
      this.setState({ listNamQH: res });
    }
  }

  async getDataMatBang() {
    let res = await AxiosGetSecretApi("/api/qh-chung/cbMatBang");
    if (res && Array.isArray(res)) {
      this.setState({ listMatBang: res });
    }
  }

  async getDataLoaiDat() {
    let res = await AxiosGetSecretApi("/api/qh-chung/cbtenloaidat");
    if (res && Array.isArray(res)) {
      this.setState({ listLoaiDat: res });
    }
  }
  //--------------------==========--------------------

  onChangeNamQH(value) {
    this.setState({
      selectedNamQH: value,
    });
    
  }

  onChangeMatBang(value) {
    this.setState({
      selectedMatBang: value,
    });
  }

  onChangeLoaiDat(value) {
    this.setState({
      selectedLoaiDat: value,
    });
  }

  onResetButton() {
    this.map.current.handleCloseClick();
    this.onSearchClick("TimMoi");
    this.setState({
      selectedNamQH: undefined,
      selectedMatBang: undefined,
      selectedLoaiDat: undefined,

      currentIndex: null,
      isShowSearchResult: undefined,
      resetButton: !this.state.resetButton,
      dataFile: []
    });
  }

  // table
  SetStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  handleTableChange = async (pagination) => {
    await this.SetStateAsync({ pagination });
    this.onSearchClick('pagination');
  };

  onSearchClick = async (e) => {
    this.setState({
      isLoading: true,
    });

    if (e === "TimKiem") {
      await this.SetStateAsync({
        pagination: { pageSize: 10, total: 1, current: 1 },
        currentIndex: null,
      });
    }
    let query = ''
    let url = "";
    if (e === "TimMoi") {
      url = `/api/qh-chung/search?curPage=1&pageSize=10`;
      this.setState({query})
    } else {
      url = `/api/qh-chung/search?curPage=${this.state.pagination.current}&pageSize=${this.state.pagination.pageSize}&`;

      if (this.state.selectedNamQH) {
        query = query + `NamQH=${this.state.selectedNamQH}&`
        url = url + `NamQH=${this.state.selectedNamQH}&`;
      }

      if (this.state.selectedLoaiDat) {
        let TenLoaiDat = encodeURIComponent(this.state.selectedLoaiDat);
        query = query + `TenLoaiDat=${TenLoaiDat}&`
        url = url + `TenLoaiDat=${TenLoaiDat}&`;
      }

      if (this.state.selectedMatBang) {
        let LoaiQH = encodeURIComponent(this.state.selectedMatBang);
        query = query + `LoaiQH=${LoaiQH}&`
        url = url + `LoaiQH=${LoaiQH}&`;
      }
    }
    

    if (e === "pagination") {
      url = `/api/qh-chung/search?curPage=${this.state.pagination.current}&pageSize=${this.state.pagination.pageSize}&`;
      query = this.state.query;
      url = url + query;
    }
    
    if (e === "TimKiem") {
      this.setState({query: query})
      // this.map.current.onChangeLayerByNamQH(this.state.selectedNamQH);
    }

    let res = await AxiosGetSecretApi(url);
    let dataTable = [];
    if (res && res.dataResult) {
      dataTable = res.dataResult.map((o, index) => {
        return {
          ...o,
          key:
            index +
            1 +
            (this.state.pagination.current - 1) *
              this.state.pagination.pageSize,
        };
      });
      this.setState({
        dataTable: dataTable,
        pagination: res.dataPaginate,
        isLoading: false,
      });
    } else {
      this.setState({
        dataTable: dataTable,
        pagination: this.state.pagination,
        isLoading: false,
      });
    }
  };

  onSearchByObjectId = async (id) => {
    this.setState({
      isLoading: true,
    });

    let url = `/api/qh-chung/search?curPage=1&pageSize=100&OBJECTID=${id}`;

    let res = await AxiosGetSecretApi(url);
    let dataTable = [];
    if (res && res.dataResult) {
      dataTable = res.dataResult.map((o, index) => {
        return {
          ...o,
          stt:
            index +
            1 +
            (this.state.pagination.current - 1) *
              this.state.pagination.pageSize,
        };
      });
      if (res.dataResult.length !== 0) {
        this.getGeoData(res.dataResult[0].OBJECTID, res.dataResult[0].LoaiQH);
        this.getFile(res.dataResult[0].IDNamQHChung);
        this.setState({
          currentIndex: 0,
          dataSearch: res.dataResult[0],
          isShowSearchResult: "search",
          pagination: res.dataPaginate,
        });
      } else {
        this.setState({
          pagination: res.dataPaginate,
        });
      }
    }
    this.setState({
      dataTable: dataTable,
      pagination: this.state.pagination,
      isLoading: false,
    });
  };

  onShowSearchResult = () => {
    this.setState({
      isShowSearchResult: "search",
    });
  };

  onCloseSearchResult = () => {
    this.setState({
      isShowSearchResult: "button",
    });
  };

  async getFile(id) {
    let res = await AxiosGetSecretApi(`/api/qh-chung/getAllAsset?ID=${id}`);
    if (res && Array.isArray(res) && res.length !== 0) {
      this.setState({
        dataFile: res,
      });
    }else{
      this.setState({
        dataFile: [],
      });
    }
  }

  async getGeoData(id, type) {
    let url = "";
    if (type === "Hiện trạng") {
      url = `https://gis-quyhoach.greenglobal.vn/server/rest/services/SoXayDung/MatBangPolygon_HienTrang/MapServer/0/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${id}&outFields=*&outSR=102100`;
    } else {
      url = `https://gis-quyhoach.greenglobal.vn/server/rest/services/SoXayDung/QuyHoachDoThi/MapServer/5/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${id}&outFields=*&outSR=102100`;
    }
    // if(this.state.selectedNamQH === '2020'){
    //   url = `/arcgis/rest/services/SoXayDung/MatBangQHChung_Test/MapServer/0/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${id}&outFields=*&outSR=102100`;
    // }
    let res = await AxiosGetSecretApi(url);

    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].geometry &&
      res.features[0].geometry.rings
    )
      this.map.current.drawRing(res.features[0].geometry.rings);
      
  }

  render() {
    return (
      <MainLayout {...this.props} title={"Quy hoạch chung 1/10000"}>
        <div className="quy-hoach-main">
          <div style={{ padding: "10px" }}>
            <div className="quy-hoach">
              <div className="quy-hoach-header">
                Danh sách Dự án Quy hoạch chung 1/10000
              </div>

              <div className="quy-hoach-body">
                <div className="search-input">
                  <Row gutter={[20, 0]} style={{ marginBottom: "15px" }}>
                    <Col span={12}>
                      <div className="group">
                        <div className="gr-title">
                          <div className="text">Năm quy hoạch</div>
                        </div>

                        <div className="gr-body">
                          <Select
                            className="select"
                            showSearch
                            value={this.state.selectedNamQH}
                            onChange={(value) => this.onChangeNamQH(value)}
                          >
                            {this.state.listNamQH.map((e, i) => (
                              <Select.Option value={e.NamQH} key={i}>
                                {e.NamQH}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </Col>

                    <Col span={12}>
                      <div className="group">
                        <div className="gr-title">
                          <div className="text">Mặt bằng</div>
                        </div>

                        <div className="gr-body">
                          <Select
                            className="select"
                            showSearch
                            value={this.state.selectedMatBang}
                            onChange={(value) => this.onChangeMatBang(value)}
                          >
                            {this.state.listMatBang.map((e, i) => (
                              <Select.Option value={e.LoaiQH} key={i}>
                                {e.LoaiQH}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row gutter={[20, 0]} style={{ marginBottom: "15px" }}>
                    <Col span={12}>
                      <div className="group">
                        <div className="gr-title">
                          <div className="text">Tên loại đất</div>
                        </div>

                        <div className="gr-body">
                          <Select
                            className="select"
                            showSearch
                            value={this.state.selectedLoaiDat}
                            onChange={(value) => this.onChangeLoaiDat(value)}
                          >
                            {this.state.listLoaiDat.map((e, i) => (
                              <Select.Option value={e.TenLoaiDat} key={i}>
                                {e.TenLoaiDat}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <div style={{ display: "flex" }}>
                    <Button
                      type="primary"
                      onClick={() => {
                        this.onResetButton();
                      }}
                      className="search-button"
                    >
                      Tìm mới
                    </Button>

                    <Button
                      type="primary"
                      onClick={()=>this.onSearchClick("TimKiem")}
                      className="search-button"
                    >
                      Tìm kiếm
                    </Button>
                  </div>
                </div>
              </div>

              <div className="quy-hoach-footer">
                <Table
                  // style={{ height: "calc(100vh - 384px)", overflow: "auto" }}
                  columns={this.columns}
                  dataSource={this.state.dataTable}
                  locale={{ emptyText: "Không có dữ liệu" }}
                  bordered
                  pagination={{
                    ...this.state.pagination,
                    showSizeChanger: false,
                  }}
                  onChange={this.handleTableChange}
                  size="small"
                  loading={this.state.isLoading}
                  rowKey={(record) => record.OBJECTID}
                  rowClassName={(record, index) =>
                    index +
                      (this.state.pagination.current - 1) *
                        this.state.pagination.pageSize ===
                    this.state.currentIndex
                      ? "highlight"
                      : "not-highlight"
                  }
                  onRow={(record, rowIndex) => {
                    return {
                      onClick: async (event) => {
                        // this.map.current.drawPolygon(record.SHAPE);
                        this.getGeoData(record.OBJECTID, record.LoaiQH);
                        this.getFile(record.IDNamQHChung);
                        this.setState({
                          currentIndex:
                            rowIndex +
                            (this.state.pagination.current - 1) *
                              this.state.pagination.pageSize,
                          dataSearch: record,

                          isShowSearchResult: "search",
                          // dataFileSearchResuld,
                          // isShowSearchResult: true,
                          // isShowButtonInfo: true,
                          // showProgressBar: false,
                          // OBJECTID: record.OBJECTID,
                          // isEnableEditButton: true,
                        });
                      }, // click row
                    };
                  }}
                />
              </div>
              {this.state.isShowSearchResult === "search" && (
                <SearchResult10000
                  data={this.state.dataSearch}
                  file={this.state.dataFile}
                  close={this.onCloseSearchResult}
                ></SearchResult10000>
              )}

              {/* {this.state.isShowSearchResult === "button" && (
                <Button
                  className="close-popup-result"
                  type="primary"
                  onClick={this.onShowSearchResult}
                >
                  <i className="fas fa-search"></i>
                </Button>
              )} */}
            </div>
          </div>

          <div className="quy-hoach-map">
            {/* <MapQuyHoach
              type="QHC"
              ref={this.map}
              isShowMenu={this.props.isShowMenu}
              searchDataTable={this.onSearchByObjectId}
            ></MapQuyHoach> */}
            <Map
              type="QHC"
              ref={this.map}
              resetButton={this.state.resetButton}
              selectedNamQH={this.state.selectedNamQH}
              isShowMenu={this.props.isShowMenu}
              searchDataTable={this.onSearchByObjectId}
            ></Map>
          </div>
        </div>
      </MainLayout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    isShowMenu: state.menu.isShowMenu,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(QuyHoach10000);
